'use client';
import { JumboCard, JumboScrollbar } from 'themes/jumbo/@jumbo/components';
import {
  Chip,
  Typography,
  Button,
  Fab,
  Tooltip
} from '@mui/material';
import { ProjectsList } from './components';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import {
    openHomeNewProjectDialog,
} from 'store/projects';
import { trackEvent } from "components/Tracking";
import { ProjectType } from './components/ProjectItem/types';
import { useState, useEffect } from "react";

const sortByDate = (a: ProjectType, b: ProjectType) => a.file_date > b.file_date ? 1 : -1;

const ProjectsCard = ({title, sweetAlerts, filter}:{title:React.ReactNode, sweetAlerts: () => void, filter: string}) => {
	const _projects = useSelector((state: any) => state.cache.data.projects);
  const storeAuthData = useSelector((state: any) => state.auth);
  const { defaultProjects, hasActiveSubscription = false } = storeAuthData;
  const [projects, setProjects] = useState<any[]>([]);
	const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    const data = Object.values(_projects)
                        .sort((a:any, b:any) => sortByDate(a, b))
                        .filter((item: any) => !defaultProjects.includes(item.ID))
                        .filter((item: any) => filter !== 'all' ? item.ID === filter : item.ID !== null);
    setProjects(data);
  }, [_projects, defaultProjects, filter])

  const handAllleClick = (e: any) => {
    trackEvent("Dashboard", "Projects", "Btn_All");
    history.push(`/catalog`);
  };
  const addNewClick = (e: any) => {
    if(!hasActiveSubscription) {
      sweetAlerts();
      return;
    }
    dispatch(openHomeNewProjectDialog(null));
    setTimeout(() => {
      history.push(`/catalog`);
    }, 250);
  };

  const CardTitle = () => (
    <div style={{display: "flex", justifyContent: 'space-between', height: '40px'}}>
      <div style={{display: "flex", gap: '10px', alignItems: 'center'}}>
        <Typography color={'text.primary'} variant={'h6'} mb={0}>
          {title}
        </Typography>
        <Chip
          size={'small'}
          label={projects.length}
          color='success'
          sx={{
            textAlign: 'center',
            backgroundColor: '#868484ff',
            transform: 'scale(.8)'
          }}
        />
      </div>
      
      <div style={{display: "flex", gap: '10px', alignItems: 'center'}}>
        { projects.length > 0 && (
          <Tooltip title="All Projects" placement="top" arrow>
            <Button
              size={'small'}
              variant={'outlined'}
              onClick={handAllleClick} 
              style={{height: '25px', minWidth: 'auto'}}
            >
              All
            </Button>
          </Tooltip>
        )}
        <Tooltip title="Create New Project" placement="top" arrow>
          <Fab
            size='small'
            aria-label='New project'
            onClick={(evt:any) => {
              trackEvent("Dashboard", "Projects", "Btn_Plus")
              addNewClick(evt);
            }}
            sx={{
              color: 'common.white',
              bgcolor: '#5AADE3',
              //transform: 'scale(.7)',
              '&:hover': {
                bgcolor: '#2196f3',
              },
            }}
          >
            <AddIcon />
          </Fab>
        </Tooltip>
      </div>
    </div>
  )

  return (
    <JumboCard
      title={<CardTitle />}
      contentWrapper
      contentSx={{ p: 0 }}
    >
      <JumboScrollbar autoHeight autoHeightMin={284}>
        <ProjectsList 
          projects={projects} 
          handleClick={(evt:any) => {
            trackEvent("Dashboard", "Projects", "Btn_Create_New")
            addNewClick(evt);
          }}
        />
      </JumboScrollbar>
    </JumboCard>
  );
};

export { ProjectsCard };
